(function(){
  if (window.__mpnViewer) return; window.__mpnViewer = true;
  var mob = window.matchMedia('(max-width: 749.98px)');
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  function ms(n){ return rm.matches ? 0 : n; }

  function setup(modal){
    if (modal.__mpnV) return; modal.__mpnV = true;
    var dlg = modal.querySelector('.product-media-modal__dialog');
    var content = modal.querySelector('.product-media-modal__content');
    if (!dlg || !content) return;
    var g = null, lastTap = 0, tapT = 0, closing = false, saved = null;

    function zoomed(){ return content.classList.contains('is-zoomed'); }
    function idx(){ return Math.round(content.scrollLeft / (content.clientWidth || 1)); }
    function item(){ return content.children[idx()]; }

    /* Images : largeur de l'ecran + chargement prioritaire de la photo affichee et de ses voisines */
    function prime(){
      if (!mob.matches) return;
      var list = content.children, k = idx();
      for (var j = 0; j < list.length; j++) {
        var img = list[j].tagName === 'IMG' ? list[j] : null;
        if (!img) continue;
        if (img.getAttribute('sizes') !== '100vw') img.setAttribute('sizes', '100vw');
        if (Math.abs(j - k) <= 1 || (k === 0 && j === list.length - 1) || (k === list.length - 1 && j === 0)) {
          if (img.loading !== 'eager') img.loading = 'eager';
          img.decoding = 'async';
        }
      }
    }
    var praf = 0;
    content.addEventListener('scroll', function(){ if (praf) return; praf = requestAnimationFrame(function(){ praf = 0; prime(); }); }, { passive: true });

    function paint(dy, anim){
      var el = item(); if (!el) return;
      var s = 1 - Math.min(dy, 400) / 2400;
      el.style.transition = anim ? 'transform ' + ms(200) + 'ms cubic-bezier(.2,.8,.2,1)' : 'none';
      el.style.transform = dy ? 'translate3d(0,' + dy.toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')' : '';
      dlg.style.setProperty('--mpn-v-o', Math.max(0, 1 - dy / 220).toFixed(3));
    }
    function clear(){
      [].forEach.call(content.children, function(el){ if (el.tagName !== 'IMG' || !zoomed()) { el.style.transition = ''; el.style.transform = ''; } });
      dlg.classList.remove('mpn-v-drag'); dlg.style.removeProperty('--mpn-v-o');
    }
    function back(){
      paint(0, true);
      setTimeout(function(){ if (!closing) clear(); }, ms(210));
    }
    function close(dy){
      closing = true;
      var el = item();
      if (el && ms(1)) {
        el.style.transition = 'transform ' + ms(180) + 'ms ease-in, opacity ' + ms(180) + 'ms ease-in';
        el.style.transform = 'translate3d(0,' + Math.max(dy, window.innerHeight * .6) + 'px,0) scale(.92)';
        el.style.opacity = '0';
      }
      setTimeout(function(){
        if (modal.hide) modal.hide();
        setTimeout(function(){ if (el) el.style.opacity = ''; clear(); closing = false; }, 30);
      }, ms(170));
    }

    content.addEventListener('touchstart', function(e){
      if (!mob.matches || closing || e.touches.length !== 1 || zoomed()) { if (g && g.mode === 'down') back(); g = null; return; }
      var t = e.touches[0];
      g = { x0: t.clientX, y0: t.clientY, t0: Date.now(), mode: null, dy: 0, target: e.target };
    }, { passive: true });

    content.addEventListener('touchmove', function(e){
      if (!g) return;
      if (e.touches.length !== 1 || zoomed()) { if (g.mode === 'down') back(); g = null; return; }
      var t = e.touches[0], dx = t.clientX - g.x0, dy = t.clientY - g.y0;
      if (!g.mode) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        g.mode = (dy > 0 && Math.abs(dy) > Math.abs(dx) * 1.2) ? 'down' : 'other';
        if (g.mode === 'down') dlg.classList.add('mpn-v-drag');
      }
      if (g.mode !== 'down') return;
      if (e.cancelable) e.preventDefault();
      g.dy = Math.max(0, dy);
      g.vt = Date.now();
      paint(g.dy, false);
    }, { passive: false });

    content.addEventListener('touchend', function(e){
      if (!g) return;
      var cur = g; g = null;
      if (cur.mode === 'down') {
        var v = cur.dy / Math.max(1, Date.now() - cur.t0);
        if (cur.dy > 110 || (cur.dy > 45 && v > 0.55)) close(cur.dy); else back();
        return;
      }
      if (cur.mode !== null || Date.now() - cur.t0 > 350 || e.touches.length) return;
      /* simple tap = afficher / masquer l'interface ; double tap = zoom (gere par la visionneuse) */
      var now = Date.now();
      if (now - lastTap < 320) { clearTimeout(tapT); lastTap = 0; return; }
      lastTap = now;
      if (cur.target.closest && cur.target.closest('deferred-media, product-model, video, button, a')) return;
      clearTimeout(tapT);
      tapT = setTimeout(function(){ if (!zoomed() || dlg.classList.contains('mpn-ui-hide')) dlg.classList.toggle('mpn-ui-hide'); else dlg.classList.add('mpn-ui-hide'); }, 320);
    }, { passive: true });

    content.addEventListener('touchcancel', function(){ if (g && g.mode === 'down') back(); g = null; }, { passive: true });

    /* Ouverture / fermeture : page bloquee derriere, retour exact a la meme position */
    function lock(){
      if (!mob.matches || saved) return;
      var y = window.scrollY || window.pageYOffset || 0;
      var b = document.body.style;
      saved = { y: y, pos: b.position, top: b.top, left: b.left, right: b.right, width: b.width };
      b.position = 'fixed'; b.top = (-y) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    }
    function unlock(){
      if (!saved) return;
      var s = saved; saved = null;
      var b = document.body.style;
      b.position = s.pos; b.top = s.top; b.left = s.left; b.right = s.right; b.width = s.width;
      var html = document.documentElement, sb = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, s.y);
      requestAnimationFrame(function(){ window.scrollTo(0, s.y); html.style.scrollBehavior = sb; });
      setTimeout(function(){ if (Math.abs((window.scrollY || 0) - s.y) > 2) window.scrollTo(0, s.y); }, 60);
    }
    new MutationObserver(function(){
      if (modal.hasAttribute('open')) {
        dlg.classList.remove('mpn-ui-hide'); clear(); lock();
        requestAnimationFrame(function(){ requestAnimationFrame(prime); });
      } else {
        clearTimeout(tapT); g = null; unlock();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init(){ document.querySelectorAll('product-modal').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
